export default {
  functionKey: "REGEXTEST",
  title: "REGEXTEST",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 2,
  requiredArguments: [
    { argumentKey: "Pattern", name: "Expression régulière" },
    { argumentKey: "Flags",   name: "Options (ex: i, g...)", empty: true }
  ],
  expectedArguments: [
    { name: "Expression régulière",      argumentKey: "Pattern", single: true, initialValue: "" },
    { name: "Options (ex: i, g...)",     argumentKey: "Flags",   single: true, initialValue: "", empty: true }
  ],
  description: "Teste si la valeur correspond à une expression régulière. Retourne true ou false. (Ex: REGEXTEST(valeur, '^[0-9]+$') -> true)",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const pattern = args[0] ?? "''";
    const flags   = args[1] ?? "''";
    const code = `${destination} = (new RegExp(${pattern}, ${flags})).test(${origin});`;
    return { displayCode: code, safeCode: code };
  }
}
